import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import WhatISImage from '../../../assets/images/unique/Vitamin Infusion/vitamin.jpeg';

export const VitaminInfusionParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Vitamin and nutrient support is a conversation about hydration, minerals, vitamins, amino acids, eating patterns, digestion, sleep, stress, and medical history. In a clinical setting, the goal is to understand whether symptoms may be related to nutrient status or whether another cause deserves attention first.`,
    img: WhatISImage,
  },
  {
    title: 'What it may help clarify',
    text: `This topic may be useful when discussing fatigue, recovery, hydration habits, digestive absorption, frequent stress, changes in energy, or a history of low vitamin or mineral levels. It does not mean that nutrients are always the answer; it helps organize better questions for the appointment.`,
  },
  {
    title: 'What is reviewed before deciding',
    text: `A doctor may review current supplements, medications, allergies, previous lab work, hydration habits, nutrition, chronic conditions, and symptoms that changed recently. This helps avoid guessing and supports a more personalized conversation.`,
  },
  {
    title: 'What to keep in mind',
    text: `More is not always better. Some vitamins or minerals may not be appropriate for every person, especially with certain medical conditions or medications. A private consultation helps decide whether the next step should involve lab review, lifestyle changes, nutrition, monitoring, or another clinical path.`,
  },
];
